/* ===========================
   Fabric Love - Product Member Offer
   - Display only
   - Shows member offer text for verified members only
   - No signup logic
   - No modal logic
   - Exposes OFFERS globally for member-core discount application
   - Force-applies visible offer codes on PDP as belt and braces
   =========================== */

(function () {
  function norm(s) {
    return (s || '').toString().trim();
  }

  function normUpper(s) {
    return norm(s).toUpperCase();
  }

  function parseTags(tagString) {
    return (tagString || '')
      .split('|')
      .map(function (t) { return norm(t); })
      .filter(Boolean);
  }

  function hasMemberOfferTag(tags, code) {
    const target = ('member_offer:' + normUpper(code)).toLowerCase();
    return tags.some(function (t) {
      return t.toLowerCase() === target;
    });
  }

  const OFFERS = [
    {
      key: "HUBBLE10",
      enabled: true,
      code: "HUBBLE10",
      appliedText: "Your member price is active ✓",
      appliedLink: "/collections/rose-and-hubble-fabric",
      appliedLinkText: "10% Off all Rose & Hubble fabrics",
      match: {
        vendor: ["Rose & Hubble"],
        productType: [],
        tags: []
      }
    },
      {
      key: "BATIK10",
      enabled: true,
      code: "BATIK10",
      appliedText: "Your member price is active ✓",
      appliedLink: "/collections/batik-fabric",
      appliedLinkText: "10% Off all Batik Cottons",
      match: {
        vendor: [],
        productType: [],
        tags: ["batik"]
      }
    },
    {
      key: "QUILT5",
      enabled: true,
      code: "QUILT5",
      appliedText: "£5 off for members is available ✓",
      appliedLink: "/collections/quilting-fabrics",
      appliedLinkText: "Spend £40 on quilting fabrics",
      match: {
        vendor: [],
        productType: ["Quilting Cotton"],
        tags: []
      }
    },
    {
      key: "JOHNNY10",
      enabled: true,
      code: "JOHNNY10",
      appliedText: "Your member price is active ✓",
      appliedLink: "/collections/little-johnny-fabrics",
      appliedLinkText: "10% Off all Little Johnny fabrics",
      match: {
        vendor: ["Little Johnny"],
        productType: [],
        tags: []
      }
    }
  ];

  window.FL_OFFERS = OFFERS;

  function isEligible(offer, tags, vendor, productType) {
    if (hasMemberOfferTag(tags, offer.code)) return true;

    const vendors = (offer.match && offer.match.vendor) || [];
    if (vendors.length && vendors.some(function (v) { return v === vendor; })) {
      return true;
    }

    const types = (offer.match && offer.match.productType) || [];
    if (types.length && types.some(function (t) { return t === productType; })) {
      return true;
    }

    const matchTags = (offer.match && offer.match.tags) || [];
    if (
      matchTags.length &&
      matchTags.some(function (matchTag) {
        return tags.some(function (productTag) {
          return normUpper(productTag) === normUpper(matchTag);
        });
      })
    ) {
      return true;
    }

    return false;
  }

  function renderOfferHTML(offer) {
    return `
      <div class="fl-offer-root">
        <div
          class="fl-offer-container fl-offer-container--applied"
          data-fl-member-offer
          data-offer-key="${offer.key}"
          data-discount-code="${offer.code}"
        >
          <div class="fl-offer-image">
            <img
              src="https://cdn.shopify.com/s/files/1/0742/2037/files/member_offer_logo.png?v=1771243094"
              alt="Member offer"
            >
          </div>

          <div class="fl-offer-text">
            <div class="fl-offer-applied is-on">
              <div class="fl-offer-applied-main">${offer.appliedText}</div>
              <a href="${offer.appliedLink}" class="fl-offer-applied-sub fl-offer-applied-link">
                ${offer.appliedLinkText}
              </a>
            </div>
          </div>
        </div>
      </div>
    `.trim();
  }

  function clearMount(mount) {
    mount.innerHTML = '';
    mount.style.display = 'none';
  }

  async function renderOffers() {
    const mount = document.querySelector('[data-fl-member-offers]');
    if (!mount) return;

    const isMember = !!(
      window.FLMember &&
      typeof window.FLMember.isVerifiedMember === 'function' &&
      window.FLMember.isVerifiedMember()
    );

    if (!isMember) {
      clearMount(mount);
      return;
    }

    const tags = parseTags(mount.getAttribute('data-tags') || '');
    const vendor = norm(mount.getAttribute('data-vendor') || '');
    const productType = norm(mount.getAttribute('data-product-type') || '');

    const eligibleOffers = OFFERS
      .filter(function (offer) {
        return offer && offer.enabled && offer.code;
      })
      .filter(function (offer) {
        return isEligible(offer, tags, vendor, productType);
      });

    if (!eligibleOffers.length) {
      clearMount(mount);
      return;
    }

    mount.innerHTML = eligibleOffers.map(renderOfferHTML).join('\n');
    mount.style.display = 'block';

    if (
      window.FLMember &&
      typeof window.FLMember.forceApplyCodes === 'function'
    ) {
      await window.FLMember.forceApplyCodes(
        eligibleOffers.map(function (offer) {
          return offer.code;
        })
      );
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderOffers();
  });

  window.addEventListener('fl_member_state_changed', function () {
    renderOffers();
  });
})();